export default (ctx, inject) => {
  inject('powerOfTwo', (value) => {
    if (!value) {
      return
    }
    return Math.pow(2, value)
  })
}
